import React, { useState, useEffect, useContext } from 'react';
import Navbar from './Navbar';
import UserInfo from './UserInfo';
import AuthContext from '../context/AuthContext';
import axios from 'axios';
import Loading from './Loading';
import { API_BASE_URL } from '../config/adminConfig';

function UserStats() {
    const { token, logout } = useContext(AuthContext);
    const [allUsers, setAllUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const apiCalls = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/admin/getAllUsers`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                setAllUsers(response.data.users || []);
                setError(null);
            } catch (err) {
                if (err.response?.status === 401) {
                    logout();
                    return;
                }
                setError(err.response?.data?.message || 'Unable to load users.');
            } finally {
                setLoading(false);
            }
        }
        apiCalls();
    }, [token, logout]);

    if (loading) {
        return (
            <Loading/>
        )
    }

    return (
        <div>
            <Navbar />
            {error ? <div style={{ padding: '24px', color: '#B00020' }}>{error}</div> : null}
            <UserInfo users={allUsers} />
        </div>
    );
}
export default UserStats;
